module.exports = __webpack_public_path__ + "media/images/v4/video-bg-53d503ec07a24c796677342aa59ba78f.png";